import _ from 'lodash';
import * as actions from 'app/actions/subscriptions';

export const SUBSCRIPTION_STATES = {
  pending: 'pending',
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
};

export const DEFAULT_STATE = _.assign({}, {
  state: SUBSCRIPTION_STATES.pending,
  managePending: false,
  current: null,
  addedUsers: null,
});

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    // Uses default state to initialize!
    case actions.LOADING_SUBSCRIPTIONS: {
      return Object.assign({}, DEFAULT_STATE, {
        state: SUBSCRIPTION_STATES.loading,
      });
    }
    // Intentionally does not clear other state!
    case actions.RELOADING_SUBSCRIPTIONS: {
      return Object.assign({}, state, {
        state: SUBSCRIPTION_STATES.loading,
      });
    }
    case actions.SET_SUBSCRIPTIONS_STATUS: {
      let newState = Object.assign({}, state, {
        current: _.get(action, 'result'),
      });

      if (_.get(newState, 'addedUsers') !== null) {
        newState = Object.assign({}, newState, {
          state: SUBSCRIPTION_STATES.loaded,
        });
      }
      // TODO: handle errors?

      return newState;
    }
    case actions.SET_SUBSCRIPTIONS_USERS: {
      let newState = Object.assign({}, state, {
        addedUsers: _.get(action, 'result'),
        state: SUBSCRIPTION_STATES.loaded,
      });

      if (_.get(newState, 'current') !== null) {
        newState = Object.assign({}, newState, {
          state: SUBSCRIPTION_STATES.loaded,
        });
      }
      // TODO: handle errors?

      return newState;
    }
    case actions.SUBSCRIPTIONS_USER_ADDED : {
      // TODO: not clear what needs to be done here yet
      return state;
    }
    case actions.SUBSCRIPTIONS_USER_REMOVED : {
      // TODO: not clear what needs to be done here yet
      return state;
    }
    case actions.MANAGE_PENDING : {
      return Object.assign({}, state, { managePending: true });
    }
    case actions.MANAGE_DONE : {
      return Object.assign({}, state, { managePending: false });
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./app/reducers/subscriptions.js